import React from "react";
import { Control } from "react-hook-form";

import DatePickerIcon from "~/components/Icons/svg/datepicker";
import Button from "~/shared/ui/Fields/Button";
import DatePicker from "~/shared/ui/Fields/DatePicker";
import MultiSelect from "~/shared/ui/Fields/MultiSelect";
import Select from "~/shared/ui/Fields/Select";

import { LOCALIZE_DEALERS } from "./options";

import s from "./styles.less";

export interface FormReportValuesIProps {
  selectReport: { value: number; label: string };
  dealers: { value: string | number; label: string }[] | [];
  localizeDealers: { value: string; label: string };
  dynamicValues: { value: string | number; label: string }[] | [];
  startDate: Date;
  endDate: Date;
}

interface FormReportIProps {
  control: Control<FormReportValuesIProps>;
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  optionReport: { value: number; label: string }[];
  fullForm: number;
  data: { label: string; value: string }[] | [];
  isLoading: boolean;
  filterType: string | undefined;
  currentDynamicOptions: { value: string; label: string }[];
  closeModalSelectReport: () => void;
  startDate: string;
  endDate: string;
  minDate: Date;
  selectReport: { value: number; label: string };
  dynamicValuesError?: string;
}

const FormReport = ({
  control,
  onSubmit,
  optionReport,
  fullForm,
  data,
  isLoading,
  filterType,
  currentDynamicOptions,
  closeModalSelectReport,
  startDate,
  endDate,
  minDate,
  selectReport,
  dynamicValuesError,
}: FormReportIProps) => {
  return (
    <form className={s.formStyle} onSubmit={onSubmit}>
      <div>
        <Select
          control={control}
          options={optionReport}
          name="selectReport"
          newStyle
        />
      </div>
      {fullForm !== 1 && fullForm !== 4 && !isLoading && data && (
        <div className={s.additionalReport}>
          {(fullForm === 2 || fullForm === 5) && (
            <div>
              <span className={s.titleBolck}>Дилер</span>
              <MultiSelect
                name={"dealers"}
                control={control}
                options={data}
                label={""}
                newStyle={true}
                placeholder={"Все дилеры"}
              />
            </div>
          )}
          {fullForm === 3 && (
            <>
              <div>
                <span className={s.titleBolck}>Отфильтровать</span>
                <Select
                  control={control}
                  options={LOCALIZE_DEALERS}
                  name="localizeDealers"
                  newStyle
                />
              </div>
              <div>
                <span className={s.titleBolck}>Значения</span>
                <MultiSelect
                  key={filterType}
                  name={"dynamicValues"}
                  control={control}
                  options={currentDynamicOptions}
                  label={""}
                  newStyle={true}
                  error={dynamicValuesError}
                />
              </div>
            </>
          )}
          {(fullForm === 2 || fullForm === 3) && (
            <div>
              <span className={s.titleBolck}>Период</span>
            <div className={s.dates}>
              <DatePicker
                name={"startDate"}
                control={control}
                customClassName={s.date_picker_custom}
                customInput={
                  <p>
                    <span style={{ textTransform: "lowercase" }}>
                      от {startDate}
                    </span>
                    <DatePickerIcon />
                  </p>
                }
              />
              <span>-</span>
              <DatePicker
                name={"endDate"}
                control={control}
                customClassName={s.date_picker_custom}
                minDate={minDate}
                customInput={
                  <p>
                    <span style={{ textTransform: "lowercase" }}>
                      до {endDate}
                    </span>
                    <DatePickerIcon />
                  </p>
                }
              />
            </div>
          </div>
          )}
        </div>
      )}
      <div className={s.footerBtnWrapp}>
        <Button
          txtBtn="Отмена"
          customClassName={s.btnClass}
          onClick={closeModalSelectReport}
          isForm={false}
        />
        <Button
          txtBtn="Выгрузить Отчет"
          orange
          customClassName={s.btnClass}
          isForm={true}
        />
      </div>
    </form>
  );
};

export default FormReport;
